const API_URL = import.meta.env.VITE_API_URL || "http://localhost:3001";

export const MENUS_ENDPOINTS = {
  BASE: `${API_URL}/menus`,
  SAVE: `${API_URL}/menus`,
  GET_CURRENT: `${API_URL}/menus/current`,
} as const;

export default MENUS_ENDPOINTS;
